import * as variables from './variables.js';
import * as $ from 'jquery';

import 'window.requestanimationframe';
import 'es6-promise/auto';
import 'intersection-observer';
import 'whatwg-fetch';

import JSFAjaxJQueryAdapter from '@plaudit/jsf-ajax-adapters/dist/jQuery';
JSFAjaxJQueryAdapter.init();

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	//hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});

import initAddClass from './component/AddClassOnScroll';
initAddClass();

import initTabs from './component/Tabs';
initTabs();

import Carousel from './component/Carousel/Carousel';
const carouselEl = document.getElementsByClassName('projectCarousel');
for (let i = 0; i < carouselEl.length; i++) {
	new Carousel({
		carouselEl: carouselEl[i] as HTMLElement,
		carouselClass: 'projectCarousel',
		doLazyLoad: true,
		doIndicators: true,
		doLightbox: true,
		duration: 4500
	});
}

import IconAnimation from './component/IconAnimation';
new IconAnimation(variables);


/* TEAM SLIDER */
if (ViewportTracker.below('mobileMenu', true)) {
	$('.team .person').unwrap();
	$('.team .person').addClass('team__slide');
}
import Team from './component/Team';
const teamEl = document.getElementsByClassName('team');
for (let i = 0; i < teamEl.length; i++) {
	new Team({
		carouselEl: teamEl[i] as HTMLElement,
		carouselClass: 'team'
	});
}
/* ============= */

import AutoLoadPages from './lib/AutoLoadItems';

const autoLoadOpsArr = [{
	frameId: 'newsListing__list',
	nextClass: 'btn--next',
	resultsClass: 'listItem',
	paginationClass: 'pagination'
}, {
	frameId: 'bottomProjects',
	nextClass: 'btn--next',
	resultsClass: 'listItem',
	paginationClass: 'pagination'
}];
let autoLoaders: AutoLoadPages[] = [];
for (let i = 0; i < autoLoadOpsArr.length; i++) {
	autoLoaders.push(new AutoLoadPages(autoLoadOpsArr[i]));
}

/* MASTHEAD VIDEO */
import Lightbox from './component/Lightbox/Lightbox';
const mastheadVideo = new Lightbox({
	type: 'video',
	triggerEl: document.querySelectorAll('.masthead__video')
});

import MapController from './component/Map';
MapController();
